import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 全局状态
    user: null,
    loading: false
  },
  mutations: {
    // 同步修改状态
    SET_USER(state, user) {
      state.user = user
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    }
  },
  actions: {
    // 异步操作
    setUser({ commit }, user) {
      commit('SET_USER', user)
    },
    setLoading({ commit }, loading) {
      commit('SET_LOADING', loading)
    }
  },
  getters: {
    // 计算属性
    isAuthenticated: state => !!state.user,
    isLoading: state => state.loading
  }
}) 